import React from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useVehicle } from "@/hooks/useVehicles";
import StockVehicleDetail from "@/pages/StockVehicleDetail";

const VehicleDetail: React.FC = () => {
  const { slug } = useParams();
  const { vehicle, loading, error } = useVehicle(slug);

  if (loading) {
    return <main className="container-x py-24 text-center text-slate-500">Loading vehicle details...</main>;
  }

  if (error || !vehicle || vehicle.status !== "published") {
    return (
      <main className="container-x py-24 text-center">
        <h1 className="text-3xl font-extrabold text-slate-900">Vehicle not available</h1>
        <p className="mt-3 text-slate-500">This vehicle may have been sold or removed from the public inventory.</p>
        <Link to="/vehicles/" className="btn-blue mt-6 inline-flex"><ArrowLeft className="h-4 w-4" /> Back to vehicles</Link>
      </main>
    );
  }

  return <StockVehicleDetail vehicle={vehicle} />;
};

export default VehicleDetail;
